// ============================================================
// TRACKING & WEBMASTER IDS — paste IDs here, rebuild, redeploy.
// All tools stay OFF until an ID is filled in.
// See /app/frontend/TRACKING-README.md for where to find each ID.
// ============================================================
export const TRACKING = {
  GTM_ID: "", // Google Tag Manager container, e.g. "GTM-ABC1234"
  GA4_ID: "", // GA4 measurement ID, e.g. "G-XXXXXXXXXX"
  GA4_VIA: "gtm", // "gtm" = configure GA4 inside GTM; "direct" = load gtag.js here
  CLARITY_ID: "", // Microsoft Clarity project ID
  META_PIXEL_ID: "", // Meta (Facebook) Pixel ID, long number
  GOOGLE_ADS_ID: "AW-17444369903", // Google Ads conversion ID, e.g. "AW-XXXXXXXXXX" (no GTM needed)
  GADS_QUOTE_LABEL: "LL37CN6g06EdEO_rj_5A", // conversion label for quote/lead submissions (from the Ads conversion action)
  GADS_CONTACT_LABEL: "lO7VCLuQ1aEdEO_rj_5A", // conversion label for phone/WhatsApp clicks
  GSC_VERIFICATION: "", // google-site-verification content value
  BING_VERIFICATION: "", // msvalidate.01 content value
};
